module.exports = __webpack_public_path__ + "img/cfd3e2247b99a483538b2ff6d8a56218.svg";